module.exports = __webpack_public_path__ + "img/2012-12-14 20.14.24.fa7d30c3.jpg";